import { useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { TIME_VALUES } from '~/Constants/Date.constants';
import { PROVIDER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { AvailableProviders } from '~/Models/DTO/AvailableProviders.model';
import { ICityCountry } from '~/Models/DTO/CoreProvider.model';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { useProvider } from '~/Hooks';
export const useRequestAvailableProviders = (_?: any, refetchOnMount = true) =>
  useQuery<AvailableProviders[], IErrorResponse>(
    [REQUEST_ACTIONS.GET_AVAILABLE_PROVIDERS],
    async () =>
      requestReactQuery<AvailableProviders[]>({
        url: PROVIDER_SERVICE_URLS.AVAILABLE_PROVIDERS,
        config: { method: 'GET' },
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount,
      refetchInterval: TIME_VALUES.HOUR,
      initialData: [],
    },
  );

export const useRequestCitiesCountries = ({ ...params }: { [key: string]: unknown }) => {
  const { currentProvider } = useProvider();

  return useQuery<ICityCountry[], IErrorResponse>(
    [REQUEST_ACTIONS.GET_CITY_COUNTRY_LIST, params, currentProvider?.uuid],
    async () => {
      const acceptFilter = ['DE', 'NL', 'BE', 'FR', 'AT', 'PT', 'ES'];
      const cityCountry = await requestReactQuery<ICityCountry[]>({
        url: PROVIDER_SERVICE_URLS.GET_CITY_COUNTRY_LIST,
        config: { method: 'GET' },
      });

      return cityCountry
        .filter((city) => acceptFilter.includes(city.code))
        .map((country) => ({
          ...country,
          cities: country?.cities.map((city: any) =>
            typeof city === 'string' ? city : city?.name || '',
          ),
          codeA2: country?.code,
          nameEnglish: country?.name,
        }));
    },
    {
      refetchInterval: TIME_VALUES.HOUR,
      initialData: [],
    },
  );
};
